import Person from '@/types/Person.interface'
import jsPDF from 'jspdf'
import '../../public/js/DancingScript-Regular-normal.js'
import { store } from '@/store'

export default {
    grid: {
        lineHeight: 5,
        marginTop: store && store.getters.browser === "Safari" ? 20 : 10,
        pHeight: 300,
        pWidth: 220,
        lWidth: 180,
        grey: '255,0,0'
    },
    columns: {
        1: 15,
        2: 40,
        3: 100,
        4: 125,
        9: 195,
    },
    lsColumns: {
        1: 15,
        2: 45,
        3: 85,
        4: 115,
        5: 140,
        6: 185,
        7: 230,
        8: 265,
        9: 285
    },
    linePosition(line: number): number {
        return this.grid.marginTop + (line * this.grid.lineHeight)
    },
    drawCustomerCard(doc: jsPDF, person: Person, start: number): jsPDF {
        //  Safari handles margin in a strange way, adjust margins for safari
        this.grid.marginTop = store.getters.browser == 'Safari' ? 20 : 10

        let ln = start
        const column = this.columns
        const shipping = person.address_shipping
        const billing = person.address_billing

        const notes = person.notes ? person.notes : ''

        //  Grab the person phones
        const personPhones = person.phones || []

        const phones = {
            home:  personPhones.find(x => x && x.type === 'HOME') || 'none',
            mobile: personPhones.find(x => x && x.type === 'MOBILE') || 'none',
            work: personPhones.find(x => x && x.type === 'WORK') || 'none'
        }

        const drawPhoneBlock = (label, phone) => {
            // Always display phone field label
            doc.text(label + ': ', column[1], this.linePosition(ln))

            // Note that these property accessors get translated through Babel
            // and you might normally expect them to return `undefined` instead
            // of throwing an exception.
            
            if(phone !== null) {
                let phoneIsDefault = phone && phone.default
                let phoneNum = phone && phone.free_form_number
                let filteredNum = window.root.$options.filters.phone(phoneNum) || ''

                phoneIsDefault && doc.setFont('bold')
                doc.text(filteredNum, column[2], this.linePosition(ln))
                phoneIsDefault && doc.setFont('normal')
            }
        }


        //  Customer Name
        ln++
        doc.setFontSize(14)
        //  Name defaults to a combination of first and last name
        let name = person.name_given + ' ' + person.name_family
        //  Only do this if they have a full name
        if (person.name_full) {
            let nameArr = person.name_full.match(/.{1,80}/g)
            if (nameArr) {
                for (let i = 0; i < nameArr.length; i++) {
                    doc.text(nameArr[i] || '', column[1], this.linePosition(ln))
                    ln++;
                }
            }
            else {
                doc.text(name, column[1], this.linePosition(ln))
                ln++;
            }
        }
        else {
            doc.text(name, column[1], this.linePosition(ln))
            ln++;
        }
        
        
        doc.setFontSize(10)

        //  Address Blocks
        // (still allow print when addresses are unpopulated)
        if(billing && shipping) {
            ln++
            doc.text('BILLING ADDRESS:', column[1], this.linePosition(ln))
            doc.text('SERVICE ADDRESS:', column[3], this.linePosition(ln))
            ln++
            doc.text(billing.line1 ? billing.line1 : '', column[1], this.linePosition(ln))
            doc.text(shipping.line1 ? shipping.line1 : '', column[3], this.linePosition(ln))
            ln++
            doc.text( (billing.city ? billing.city : '') + ', ' + (billing.country_subdivision ? billing.country_subdivision : '') + (billing.postalcode ? billing.postalcode : ''), column[1], this.linePosition(ln))
            doc.text( (shipping.city ? shipping.city : '') + ', ' +  (shipping.country_subdivision ? shipping.country_subdivision : '') + (shipping.postalcode ? shipping.postalcode : ''), column[3], this.linePosition(ln))
        }

        //  Divider
        ln++
        doc.line(column[1], this.linePosition(ln), column[9], this.linePosition(ln))

        //  Mobile Phone
        ln++
        drawPhoneBlock('Mobile Phone', phones.mobile)

        //  Company
        doc.text('Company:', column[3], this.linePosition(ln))
        doc.text((person.company ? person.company : ''), column[4], this.linePosition(ln))
        
        //  Home Phone
        ln++
        drawPhoneBlock('Home Phone', phones.home)

        //  WorkPhone
        ln++
        drawPhoneBlock('Work Phone', phones.work)

        //  Divider
        ln++
        doc.line(column[1], this.linePosition(ln), column[9], this.linePosition(ln))
        ln++

        //  Custom Fields
        if (person.extensions) {
            for (const [key, val] of Object.entries(person.extensions)) {
                doc.text(`${key}: ${val}`, column[1], this.linePosition(ln++))
            }
        }

        //  Divider
        doc.line(column[1], this.linePosition(ln), column[9], this.linePosition(ln))

        //  Notes
        ln++
        doc.text(doc.splitTextToSize(notes, this.grid.lWidth), column[1], this.linePosition(ln))

        return doc
    },
    drawLoa(payload): jsPDF {
        const doc = new jsPDF({
            unit: 'px'
        })

        //  Add our title
        doc.setFontSize(24)
        doc.text("SMS Feature Porting Letter of Authorization", 50, 40)

        //  Add our form
        doc.addImage(payload.form, 'PNG', 0, 50, 450, 250)

        //  Add our phone number and carrier
        doc.setFontSize(14)
        doc.setTextColor(0.6)
        doc.text("Phone Number:", 20, 320)
        doc.text(payload.number, 20, 340)

        doc.text("Phone Carrier:", 250, 320)
        doc.text(payload.carrier, 250, 340)

        //  Grab our current date by parsing out the time
        const now = new Date().toLocaleString().split(',')[0]

        //  Add the current date
        doc.text('Date:', 120, 380)
        doc.text(now, 120, 400)

        //  Add our signature
        doc.text("Signature:", 120, 440)
        //  If we included the image then place it here
        if (payload.signatureImg) doc.addImage(payload.signatureImg, 'PNG', 80, 460, 300, 160)
        //  Else, set our font and just type it
        else {
            //  Set our cursive font
            doc.setFont("DancingScript-Regular")
            doc.setFontSize(36)

            //  Type the name
            doc.text(payload.signatureTxt, 120, 470)
        }

        // this.print(doc)
        return doc
    },
    print(document: jsPDF): void {
        //  Convert our PDF into a blob
        const blobPDF = document.output('blob')

        //  From that blob, create a Data URL so we can download
        const blobUrl = URL.createObjectURL(blobPDF)

        // @ts-ignore this prints (ts ignore because this is imported in index.html)
        printJS(blobUrl)

        //  Clear our print queue
        store.commit('printQueueClear')
    },
    printCustomer (person: Person): void {
        //  Create our doc
        const doc = this.drawCustomerCard(new jsPDF(), person, 0)

        //  Print the doc
        this.print(doc)
    },
    printQueuePrint (): void {
        //  Grab the persons from our printqueue
        const persons = store.getters.printQueue

        //  If we do NOT have anyone in the queue, do nothing
        if (!persons || !persons.length) return

        //  Create a new JSPDF
        const doc = new jsPDF()
        const perPage = 2 //  Number of cards per page
        const pages = Math.ceil(persons.length / perPage)  //  Total number of pages that will be processed
        let p = 0  // tracks which page is currently being processed

        //  Iterate through each person in the queue
        for (let i = 0; i < persons.length; i += perPage) {

            // Draw Card One
            this.drawCustomerCard(doc, persons[i], 0)

            //  If perPage is set to 2, and the persons exists, then add the custoemr to the form
            if( perPage == 2 && persons[i+1]) {
                // Draw Card Two
                this.drawCustomerCard(doc, persons[i+1], (this.grid.pHeight / this.grid.lineHeight) / 2)
            }

            // Check if there is more pages
            p++
            if (p < pages) {
                //  Add another page
                doc.addPage()
            }
        }

        //  Print the document
        this.print(doc)
    }
}